<template>
  <div
    class="footer padding-top-sm padding-bottom-sm padding-right-ml padding-left-ml"
    :class="color"
  >
    <riseup-button
      class="button"
      :title="buttonText"
      :action="action"
      :size="'slim'"
      :variant="'primary'"
      :loading="loading"
    />
    <div
      v-if="extraText"
      class="margin-top-m ri-glbl-small-body"
    >
      {{ extraText }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import RiseupButton from '@riseupil/base-ui/src/components/RiseupButton.vue';
import { storeToRefs } from 'pinia';
import { useSubscriptionStore } from '../../stores/subscription';

interface Props {
  buttonText: string
  color: string
  extraText?: string
  action: () => void
}
defineProps<Props>();

const subscriptionStore = useSubscriptionStore();
const {
  loading,
} = storeToRefs(subscriptionStore);
</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';
.footer {
  position: sticky;
  bottom: 0;
  box-shadow: -20px 0px 12px 0px #BABCBF33;
  z-index: 1000;
  .button {
    border-radius: 12px;
    font-family: CircularStd;
  }
  &.yellow {
    background-color: $riseup_light_yellow;
  }
  &.beige {
    background-color: #FCF7ED;
  }
  &.green {
    background-color: $riseup_dark_green;
  }
}

</style>
